<script setup lang="ts">
  const { t } = useI18n()
  const localePath = useLocalePath()
  const homePath = computed(() => localePath('/'))
  const helpdeskLink = computed(() => localePath('/portal/helpdesk'))
</script>

<template>
  <div class="min-h-screen bg-white flex flex-col">
    <header
      class="h-20 px-4 lg:px-12 border-b border-[#e3e3e3] flex items-center gap-4 lg:gap-6 shrink-0 bg-white"
    >
      <NuxtLink :to="homePath">
        <img alt="logo" src="/icons/Logo.svg" class="h-8 w-auto" />
      </NuxtLink>
      <div class="flex items-center gap-2 lg:gap-3 ml-auto">
        <BasicBtn
          class="flex items-center justify-center gap-1 px-2 lg:px-6 py-2s min-w-max"
          size="regular"
          color="affirmative"
          is-link
          :link="t('nav.menu.supportLink')"
          target="_support"
        >
          <img :alt="t('nav.menu.support')" src="/icons/help-24px-white.svg" class="w-5 h-5" />
          <span class="hidden lg:inline">{{ t('nav.menu.support') }}</span>
        </BasicBtn>
        <BasicBtn
          class="flex items-center justify-center gap-1 px-2 lg:px-6 py-2s min-w-max"
          size="regular"
          color="hackerblue"
          is-link
          :link="helpdeskLink"
          target="_self"
        >
          <Icon name="material-symbols:help-outline" class="w-5 h-5" />
          <span class="hidden lg:inline">{{ t('nav.menu.helpdeskButton') }}</span>
        </BasicBtn>
      </div>
    </header>
    <main class="flex-1 flex items-center justify-center p-4 md:p-8 lg:p-12">
      <slot />
    </main>
  </div>
</template>
